import {
  Button,
  Heading,
  Stack,
  Image,
  useToast,
  Center,
} from '@chakra-ui/react'
import { FaGoogle } from 'react-icons/fa'
import { useHistory, useLocation } from 'react-router-dom'
import { Card } from '../components/Card'
import { useAuth } from '../contexts/AuthContext'
import useMounted from '../hooks/useMounted'
import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'

export default function Loginpage() {
  const history = useHistory()
  const { signInWithGoogle, initUser, currentUser } = useAuth()
  const toast = useToast()
  // const mounted = useRef(false)
  const location = useLocation()
  const [isRedirecting, setIsRedirecting] = useState(false)

  // useEffect(() => {
  //   mounted.current = true
  //   return () => {
  //     mounted.current = false
  //   }
  // }, [])

  const mounted = useMounted()

  // Auto-redirect if already logged in and there's an external redirect param
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (currentUser && params.get('redirect') && !isRedirecting) {
      handleRedirectToOrBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, location.search, isRedirecting])

  async function handleRedirectToOrBack() {
    setIsRedirecting(true)
    // Check for explicit 'redirect' query parameter first (used by external/Bolt apps)
    const params = new URLSearchParams(location.search)
    const externalRedirectUrl = params.get('redirect')

    if (externalRedirectUrl) {
      try {
        // Wait for the SSO token cookie to be set by AuthContext after login
        let tokenValue = Cookies.get('shared_sso_token');
        let retries = 0;
        // Poll for up to 5 seconds to get the token
        while (!tokenValue && retries < 20) {
          await new Promise(resolve => setTimeout(resolve, 250));
          tokenValue = Cookies.get('shared_sso_token');
          retries++;
        }

        const url = new URL(externalRedirectUrl);
        // Append it to URL for cross-subdomain SSO as web.app domain cookies don't actually share
        if (tokenValue) {
          url.searchParams.set('ssoToken', tokenValue);
          window.location.href = url.toString();
        } else {
          setIsRedirecting(false);
          toast({
            title: "SSO Login Failed",
            description: "Could not generate authentication token for the external app. Please try again or contact support.",
            status: "error",
            duration: 9000,
            isClosable: true,
          })
          return; // Abort redirect to prevent infinite loop
        }
      } catch (e) {
        setIsRedirecting(false);
        toast({
          title: "SSO Login Failed",
          description: "Invalid redirect URL provided.",
          status: "error",
          duration: 9000,
          isClosable: true,
        })
      }
    } else {
      // Fallback to internal React Router logic
      history.replace(location.state?.from ?? '/profile')
    }
  }

  return (

    <Card maxW='md' mx='auto' mt={150}>
      <Center>
        <Stack>
          <Image
            boxSize='250px'
            src={require("../assets/img/fhl-logo.png")}
          >
          </Image>
          <Heading textAlign={'center'} size='md'>
            The Future Is One
          </Heading>
          <br></br>

          <Button
            variant='solid'
            isFullWidth
            mt={50}
            colorScheme='teal'
            leftIcon={<FaGoogle />}
            onClick={() =>
              signInWithGoogle()
                .then((user) => {
                  handleRedirectToOrBack()
                })
                .catch(e => console.log(e.message))
            }
          >
            Sign in with Google
          </Button>
        </Stack>
      </Center>
    </Card>
  )
}
